export const CONSENT_COMMUNITY_API = (communityId: string) => `v1/community/${communityId}`;
export const CONSENT_PROPERTY_API = (communityId: string, propertyId: string) => `${CONSENT_COMMUNITY_API(communityId)}/properties/${propertyId}`;